<template>
  <div class="main-invest-calc">
    <div class="invest-calc-small-in-card" :class="{ wide: wide }">
      <div v-if="render == 2">
        <v-list-item style="min-height:30px">
          <h1 class="font-weight-regular">{{ livePercent }}%</h1>
        </v-list-item>
        <v-list-item style="min-height:30px">
          <p class="subtitle-1 mb-0 ml-1">
            {{ $t("components.invest.calc.yearly") }}
          </p>
        </v-list-item>
      </div>
      <div v-if="render == 1">
        <v-list-item style="min-height:20px">
          <v-list-item-content class="pa-0">
            <v-list-item-title
              >{{ $t("components.invest.calc.title") }}
              {{ priceModel | formatPrice(offer.currency) }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-card-text>
          <v-slider
            v-if="isShowSlider"
            v-model="priceModel"
            llabel="Доходность"
            tthumb-color="ex3.color"
            tthumb-label="always"
            :step="priceStep"
            :min="min"
            :max="max"
            ticks
            dense
            hide-details
            style="align-items:center;"
          >
            <template v-slot:prepend>
              <v-icon ccolor="color" @click="decrementPrice">mdi-minus</v-icon>
            </template>

            <template v-slot:append>
              <v-icon ccolor="color" @click="incrementPrice">mdi-plus</v-icon>
            </template>
          </v-slider>
        </v-card-text>
        <v-list-item style="min-height:20px;">
          <v-list-item-content class="pa-0">
            <v-list-item-title>{{
              $t("components.invest.calc.long", { month: monthModel })
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-card-text>
          <v-slider
            v-if="isShowSlider"
            v-model="monthModel"
            step="1"
            :min="minMonth"
            :max="maxMonth"
            ticks
            dense
            hide-details
          >
            <template v-slot:prepend>
              <v-icon ccolor="color" @click="decrementMonth">mdi-minus</v-icon>
            </template>

            <template v-slot:append>
              <v-icon ccolor="color" @click="incrementMonth">mdi-plus</v-icon>
            </template>
          </v-slider>
        </v-card-text>
        <v-list-item style="min-height:20px">
          <v-switch
            :disabled="isDisabledIsEachMonth"
            v-model="isEachMonth"
            inset
            :label="labelEachSwitchMonth"
            class="mt-0"
          ></v-switch>
        </v-list-item>
      </div>

      <div v-if="wide && render === 1">
        <v-list class="transparent danse__list_item" min-width="350">
          <v-list-item danse style="min-height: 30px;">
            <v-list-item-title>{{
              $t("components.invest.calc.profit")
            }}</v-list-item-title>
            <v-list-item-title class="text-right" v-if="isShowDopInfo(offer)">
              <strong>{{ liveFullPrice | formatPrice(offer.currency) }}</strong>
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            danse
            style="min-height: 30px;"
            v-if="!isShowDopInfo(offer)"
          >
            <v-list-item-title class="text-right">
              <h1>{{ liveFullPrice | formatPrice(offer.currency) }}</h1>
            </v-list-item-title>
          </v-list-item>
          <v-list-item danse style="min-height: 30px;">
            <v-list-item-subtitle class="text-right"
              >{{ liveFullPriceEachMonth | formatPrice(offer.currency) }}
              {{ $t("components.invest.calc.eachMonth") }}</v-list-item-subtitle
            >
          </v-list-item>
          <v-list-item danse style="min-height: 30px;">
            <v-list-item-title>{{ $t("components.invest.calc.percent") }}</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              <strong>{{ livePercent }}%</strong>
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item
            danse
            style="min-height: 30px;"
            v-if="isShowDopInfo(offer)"
          >
            <v-list-item-title>{{ $t("components.invest.calc.target") }}</v-list-item-title>
            <v-list-item-subtitle class="text-right">{{
              offer.complete_price | formatPrice(offer.currency)
            }}</v-list-item-subtitle>
          </v-list-item>
          <v-list-item
            danse
            style="min-height: 30px;"
            v-if="isShowDopInfo(offer)"
          >
            <v-list-item-title>{{ $t("components.invest.calc.investors") }}</v-list-item-title>
            <v-list-item-subtitle class="text-right">2</v-list-item-subtitle>
          </v-list-item>
          <v-list-item
            danse
            style="min-height: 30px;"
            v-if="isShowDopInfo(offer)"
          >
            <v-list-item-title>{{ $t("components.invest.calc.remains") }}</v-list-item-title>
            <v-list-item-subtitle class="text-right"
              >9 620 000 ₽</v-list-item-subtitle
            >
          </v-list-item>
        </v-list>
      </div>

      <v-list
        class="transparent danse__list_item"
        danse
        flat
        tile
        v-if="!wide && render === 1"
      >
        <v-list-item danse style="min-height: 30px;">
          <v-list-item-title>{{ $t("components.invest.calc.profit") }}</v-list-item-title>
          <v-list-item-title class="text-right">
            <strong>{{ liveFullPrice | formatPrice(offer.currency) }}</strong>
          </v-list-item-title>
        </v-list-item>
        <v-list-item danse style="min-height: 30px;">
          <v-list-item-title></v-list-item-title>
          <v-list-item-subtitle class="text-right"
            >{{ liveFullPriceEachMonth | formatPrice(offer.currency) }} {{ $t("components.invest.calc.eachMonth") }}</v-list-item-subtitle
          >
        </v-list-item>
        <v-list-item danse style="min-height: 30px;">
          <v-list-item-title>{{ $t("components.invest.calc.percent") }}</v-list-item-title>
          <v-list-item-subtitle class="text-right"
            >{{ livePercent }}%</v-list-item-subtitle
          >
        </v-list-item>
      </v-list>
      <div v-show="wide">
        <v-btn
          :disabled="!isInvestButtonEnable"
          x-large
          @click="onInvestClick"
          class="white--text"
          color="green accent-4"
          >{{ $t("components.invest.calc.investBtn") }} </v-btn
        >
      </div>
      <!--<v-card-actions>
        <v-btn block class="white--text" color="green accent-4">Инвестировать</v-btn>
      </v-card-actions>-->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import formatPrice from "@/mixins/filters/formatPrice";
import i18n from "@/services/i18n";

export default {
  name: "InvestCalc",
  mixins: [formatPrice],
  data: () => ({
    monthModel: 3,
    priceModel: 100000,
    priceStep: 100000,
    /*percentTable: [
      {
        from: 0,
        to: 5,
        percent_each: 11,
        percent: 11.5,
      },
      {
        from: 6,
        to: 11,
        percent_each: 13,
        percent: 14,
      },
      {
        from: 12,
        to: 17,
        percent_each: 14,
        percent: 15,
      },
      {
        from: 18,
        to: 36,
        percent_each: 15,
        percent: 16,
      },
    ],*/
    percentTable: [
      {
        from: 0,
        to: 12,
        percent_each: 12,
        percent: 12.5,
      },
      {
        from: 13,
        to: 24,
        percent_each: 14,
        percent: 14.5,
      },
      {
        from: 25,
        to: 36,
        percent_each: 13,
        percent: 13.5,
      },
    ],
    isEachMonth: false,
    min: 0,
    max: 0,
    minMonth: 0,
    maxMonth: 0,
  }),
  props: {
    offer: Object,
    wide: {
      type: Boolean,
      default: false,
    },
    render: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    monthModel(val) {
      this.$emit("change::month", val);
      if (!this.offer.realCalc) this.offer.realCalc = {};
      this.offer.realCalc.month = val;
      this.updateModelToRealCalc();
    },
    priceModel(val) {
      this.$emit("change::price", val);
      if (!this.offer.realCalc) this.offer.realCalc = {};
      this.offer.realCalc.price = val;
      this.updateModelToRealCalc();
    },
    isEachMonth(val) {
      this.$emit("change::mode", val);
      if (!this.offer.realCalc) this.offer.realCalc = {};
      this.offer.realCalc.mode = val;
      this.updateModelToRealCalc();
    },
  },
  computed: {
    ...mapState({
      userId: (state) => state.user.profile.id,
      userRole: (state) => state.user.profile.role,
    }),

    isInvestButtonEnable() {
      if (this.offer) {
        if (this.offer.user_created != this.userId && this.offer.status == 40)
          return true;
      }
      return false;
    },

    isDisabledIsEachMonth() {
      if (this.offer && this.offer.type == 4) return true;
      return false;
    },
    isShowSlider() {
      if (this.offer && this.offer.type == 4) return false;
      return true;
    },
    labelEachSwitchMonth() {
      if (this.isEachMonth) return i18n.t("components.invest.calc.isEachMonth");
      return i18n.t("components.invest.calc.isEachMonthFalse");
    },
    livePercent() {
      let result = 0;
      for (let p in this.percentTable) {
        if (this.percentTable[p].from <= this.monthModel) {
          if (this.isEachMonth) {
            result = this.percentTable[p].percent_each;
          } else {
            result = this.percentTable[p].percent;
          }
        }
      }
      return result;
    },

    liveFullPrice() {
      if (!this.livePercent) return 0;
      let percents = (this.livePercent / 12) * this.monthModel;

      return (this.priceModel / 100) * percents;
    },
    liveFullPriceEachMonth() {
      if (!this.liveFullPrice) return 0;
      return this.liveFullPrice / this.monthModel;
    },
  },

  methods: {
    onInvestClick() {
      this.$emit("invest::click");
    },
    isShowDopInfo(offr) {
      if (offr.type == 1) return false;
      return true;
    },
    decrementPrice() {
      this.priceModel -= this.priceStep;
      if (this.priceModel < this.min) this.priceModel = this.min;
    },
    incrementPrice() {
      this.priceModel += this.priceStep;
      if (this.priceModel > this.max) this.priceModel = this.max;
    },
    decrementMonth() {
      this.monthModel -= 1;
      if (this.monthModel < this.minMonth) this.monthModel = this.minMonth;
    },
    incrementMonth() {
      this.monthModel += 1;
      if (this.monthModel > this.maxMonth) this.monthModel = this.maxMonth;
    },
    getNumber(val, intMode) {
      if (intMode === true) {
        val = parseInt(val);
      } else {
        val = parseFloat(val);
      }

      if (isNaN(val)) val = 0;
      return val;
    },

    updateModelToRealCalc() {
      if (!this.offer.realCalc) this.offer.realCalc = {};
      this.offer.realCalc.month = this.monthModel;
      this.offer.realCalc.price = this.priceModel;
      this.offer.realCalc.mode = this.isEachMonth;
      this.offer.realCalc.percent = this.livePercent;
      this.offer.realCalc.profit = this.liveFullPrice;
      this.offer.realCalc.profit_each_month = this.liveFullPriceEachMonth;
    },
  },
  mounted() {
    this.min = this.getNumber(this.offer.price_min);
    this.max = this.getNumber(this.offer.price_max);

    this.minMonth = this.getNumber(this.offer.month_min, true);
    this.maxMonth = this.getNumber(this.offer.month_max, true);

    if (this.offer && this.offer.type == 4) {
      this.isEachMonth = false;
    }
    this.monthModel = this.minMonth;
    this.priceModel = this.min;

    if (this.offer.realCalc) {
      if (this.offer.realCalc.price)
        this.priceModel = this.getNumber(this.offer.realCalc.price);
      if (this.offer.realCalc.month)
        this.monthModel = Math.max(
          this.getNumber(this.offer.realCalc.month, true),
          this.minMonth
        );
      if (this.offer.realCalc.mode) this.isEachMonth = this.offer.realCalc.mode;
    }

    if (this.offer.percentTable) {
      this.percentTable = this.offer.percentTable;
    }

    if (this.offer.percent_table) {
      this.percentTable = this.offer.percent_table;
    }

    if (this.render == 2) {
      this.monthModel = this.maxMonth;
      this.priceModel = this.max;
      this.isEachMonth = false;
    }
    this.updateModelToRealCalc();
  },
};
</script>
<style lang="scss">
$widthEachPanel: 350px;
.invest-calc-small-in-card {
  padding-top: 10px;
  &.wide {
    background-color: #fffffb;
    padding: 10px;
    display: flex;
    align-items: stretch;
    flex-wrap: wrap;
    > div:not(:last-child) {
      border-right: 1px solid #d2d2d2;
    }
    > div:first-child {
      min-width: #{$widthEachPanel};
    }
    > div:last-child {
      min-width: #{$widthEachPanel};
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
